import { FieldSchema } from "@/components";

export const MULTI_SELECT_FIELD_TYPES: FieldSchema<Record<string, unknown>, unknown>["type"][] = [
  "async-multi-select",
  "check-box-group",
  "multi-select",
];
